import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class SysUserInforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'dicBusinesstypeoption'
    }


    /**
     * 查询字典列表
     * @param bid 
     */
    public updatePassword(bid){
        return this.send({bid:bid},"getDicOptions",Methods.GET)
    }
   
}